module.exports = __webpack_public_path__ + "@/assets/img/hellow_profile.29b433a3.png";